import React, { useState, useEffect } from 'react';
import {  Upload} from 'antd';
import { PlusOutlined,LoadingOutlined, FilePdfOutlined}from '@ant-design/icons';
import api from '../service/index'

export default (props) => {
	let { record, setRecord, name ,disabled, resize} = props;
	let [file, setFile] = useState([]);
	let [imageUrl, setImageUrl] = useState(false);
	let [loading, setLoading] = useState(false)
	let [uploadStart, setUploadStart] = useState(false)
	
	useEffect(() => {
		if(record[name]) {
			setImageUrl(record[name].url);
		}
	}, []);

	let handleChange = info => {
		if(!info.event && uploadStart === false) {
			setUploadStart(true)
			const formData = new FormData();
		
			formData.append('files_0', info.file.originFileObj)
			formData.append("resize",resize)
			api.post("/rest/upload", formData, { headers: { 'ContenType': 'multipart/form-data'} }).then(({ data }) => {
				if (data) {
                    console.log({data})
					setFile(data[0]);
					setImageUrl(data[0].url);
					setRecord({...record, [name]:data[0]})
					setUploadStart(false)
				}
				setLoading(false);
			});
		}
	  };

	let beforeUpload = () => { 
		setImageUrl(false)
		setLoading(true);
	}  
	const uploadButton = (
		<div  >
		  {loading ? <LoadingOutlined /> : <PlusOutlined />}
		  <div style={{ marginTop: 8 }}>Upload</div>
		</div>
	);
	
	if(name=="pdf"){
		return <>
		<Upload
        name={name}
        listType="picture-card"
        className="avatar-uploader"
        showUploadList={false}
		beforeUpload={beforeUpload}
        onChange={handleChange}
		disabled={disabled}
      >

        {imageUrl ? <FilePdfOutlined style={{ fontSize: '50px' }} /> :  uploadButton}
      
      </Upload>
	</>
	}
	else{
		return <>
		<Upload
        name={name}
        listType="picture-card"
        className="avatar-uploader"
        showUploadList={false}
		beforeUpload={beforeUpload}
        onChange={handleChange}
		disabled={disabled}
      >
        {imageUrl ? <img src={imageUrl} alt={name} style={{ width: '100%', height:'inherit', objectFit:'contain' }}  /> : uploadButton}
      </Upload>
	</>
	}
};
